/**
 * TanStack Query hooks for `manage-campaign-section-centralized-dashboard`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	manageCampaignSectionCentralizedDashboardQueryKeys,
	type CreateManageCampaignSectionCentralizedDashboardBody,
	type ListManageCampaignSectionCentralizedDashboardResponse,
	type ManageCampaignSectionCentralizedDashboardRow,
} from "./api";

export function useManageCampaignSectionCentralizedDashboardList(): UseQueryResult<ListManageCampaignSectionCentralizedDashboardResponse, Error> {
	return useQuery({
		queryKey: manageCampaignSectionCentralizedDashboardQueryKeys.list(),
		queryFn: list,
	});
}

export function useManageCampaignSectionCentralizedDashboardCreate(): UseMutationResult<ManageCampaignSectionCentralizedDashboardRow, Error, CreateManageCampaignSectionCentralizedDashboardBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: manageCampaignSectionCentralizedDashboardQueryKeys.all });
		},
	});
}

export function useManageCampaignSectionCentralizedDashboardDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: manageCampaignSectionCentralizedDashboardQueryKeys.all });
		},
	});
}
